module.exports = __webpack_public_path__ + "slider-03@2x.jpg?c2457099612e908a2d11040b1b31b111";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-03@2x.jpg
// module id = 267
// module chunks = 0